import React, {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';
import FileViewerDialog from 'components/common/Dialog/FileViewerDialog';
import { MultiMediaResponse } from 'artifacts/dtos';

type DialogProps = {
  content: ReactNode;
  media?: MultiMediaResponse;
};

type ContextValues = {
  openDialog: (props: DialogProps) => void;
  closeDialog: () => void;
};

export const FileViewerContext = createContext<ContextValues>({
  openDialog: () => {
  },
  closeDialog: () => {
  },
});

const DEFAULT_PROPS: DialogProps = {
  content: null,
  media: undefined,
} as DialogProps;

export default function FileViewerProvider({ children }: { children: ReactNode }) {
  const [props, setProps] = useState<DialogProps>(DEFAULT_PROPS);
  const [open, setOpen] = useState<boolean>(false);

  const openDialog = (_props: DialogProps) => {
    setProps({
      ...DEFAULT_PROPS,
      ..._props,
    });
    setOpen(true);
  };

  const closeDialog = useCallback(() => setOpen(false), []);

  const values = useMemo(() => ({
    openDialog,
    closeDialog,
  }), [openDialog, closeDialog]);

  return (
    <FileViewerContext.Provider value={values}>
      <FileViewerDialog
        open={open}
        onClose={closeDialog}
        {...props}
      >
        {props.content}
      </FileViewerDialog>
      {children}
    </FileViewerContext.Provider>
  );
}
